import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import type { AdminAnnouncementBannerQuery as AdminAnnouncementBannerQueryType } from './queries/__types__/AdminAnnouncementBannerQuery';
import { AdminAnnouncementBannerQuery } from './queries/AdminAnnouncementBannerQuery.graphql';

export const ADMIN_ANNOUNCEMENT_BANNER_QUERY = 'AdminAnnouncementBannerQuery';

export const preloadAdminAnnouncementBanner = () =>
	query<AdminAnnouncementBannerQueryType, {}>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: AdminAnnouncementBannerQuery,
	});
